export interface VipPricingData {
  amount: number | string;
  originalAmount?: number | string;
  discountPercent?: number;
  discounted?: boolean;
}

export const getOriginalAmount = (pricing: VipPricingData): number | string => {
  const originalAmount = Number(pricing.originalAmount);
  return Number.isFinite(originalAmount) && originalAmount > 0
    ? pricing.originalAmount as number | string
    : pricing.amount;
};

export const isDiscountedPrice = (pricing: VipPricingData): boolean => {
  const discountPercent = Number(pricing.discountPercent);
  return pricing.discounted === true
    && Number.isFinite(discountPercent)
    && discountPercent >= 1
    && discountPercent < 100;
};

export const formatDiscountLabel = (pricing: VipPricingData): string => {
  if (!isDiscountedPrice(pricing)) {
    return '';
  }
  const discount = Number(pricing.discountPercent) / 10;
  return `${discount.toFixed(1).replace(/\.0$/, '')}折`;
};
